import { cn } from "@/lib/utils";

/* eslint-disable react/no-array-index-key -- decorative placeholders; no list reorder */

type AdminTableSkeletonProps = {
  rows?: number;
  columns?: number;
  className?: string;
};

/** Lightweight loading skeleton for admin data tables. */
export function AdminTableSkeleton({
  rows = 8,
  columns = 6,
  className,
}: AdminTableSkeletonProps) {
  return (
    <div
      className={cn(
        "overflow-hidden rounded-lg border border-border",
        className
      )}
      aria-busy
      aria-label="Loading table"
    >
      <div className="divide-y divide-border bg-card">
        {Array.from({ length: rows }).map((_, ri) => (
          <div
            key={ri}
            className="flex animate-pulse gap-3 px-4 py-3 sm:gap-4 sm:px-6 sm:py-4"
          >
            {Array.from({ length: columns }).map((_, ci) => (
              <div
                key={ci}
                className="h-4 flex-1 rounded bg-muted"
                style={{ animationDelay: `${(ri + ci) * 40}ms` }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
